import React from 'react';
import permissionTemplate from './Permissions.json';
import { Collapse, Checkbox } from 'antd';
import { Permission } from '../../../../interfaces/User';

export const PermissionsView = ({
    actionPermissions,
    isCustom,
    updatePermission,
}: {
    actionPermissions: Permission;
    isCustom?: boolean;
    updatePermission?: (prev: Record<string, string>) => void;
}) => {
    const { Panel } = Collapse;

    const handlePermissionToggle = (
        sectionKey: string,
        action: string,
        checked: boolean
    ) => {
        if (!updatePermission) return;

        const current =
            actionPermissions?.[sectionKey as keyof Permission]?.split(',') ?? [];

        let updated = [...current];

        if (checked) {
            if (!updated.includes(action)) {
                updated.push(action);
            }
        } else {
            updated = updated.filter((perm) => perm !== action);
        }

        // Always produce a new object to trigger React re-render
        const newPermissions: Record<string, string> = {
            ...actionPermissions,
            [sectionKey]: updated.join(','), // Use empty string if none selected
        };

        updatePermission(newPermissions);
    };

    const getActionStatus = (sectionKey: string, action: string) => {
        const current =
            actionPermissions?.[sectionKey as keyof Permission]?.split(',') ?? [];
        return current.includes(action);
    };

    return (
        <Collapse
            accordion
            defaultActiveKey={'treasuryManagement'}
            expandIconPosition="right"
            className="!bg-transparent !border-none p-0 custom-collapse"
        >
            {permissionTemplate?.map((section) => (
                <Panel header={section.section} key={section.key}>
                    <div className="space-y-4 bg-athensGray p-2">
                        {section.permissions.map((perm, index) => {
                            const isChecked = getActionStatus(section.key, perm.action);

                            return (
                                <div
                                    key={index}
                                    className="rounded-md flex items-center gap-2"
                                >
                                    <Checkbox
                                        checked={isChecked}
                                        disabled={!isCustom}
                                        onChange={(e) =>
                                            handlePermissionToggle(
                                                section.key,
                                                perm.action,
                                                e.target.checked
                                            )
                                        }
                                        className="custom-checkbox mt-[3px] text-steelBlue text-sm font-semibold"
                                    >
                                        {perm.label}
                                    </Checkbox>
                                </div>
                            );
                        })}
                    </div>
                </Panel>
            ))}
        </Collapse>
    );
};